export default {
  UPDATE_FILTERS_START: 'UPDATE_FILTERS_START',
  UPDATE_FILTERS_SUCCESS: 'UPDATE_FILTERS_SUCCESS',
}
